import { defineNuxtPlugin } from "#imports";
import prisma from "./server/utils/prisma.mjs";
export default defineNuxtPlugin({
  name: "prisma-client",
  enforce: "pre",
  async setup() {
    return {
      provide: {
        prisma
      }
    };
  },
  env: {
    islands: true
  }
});
